"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 14 14';

var CommentFilled = function CommentFilled() {
  return _react["default"].createElement("path", {
    d: "m1.75 0.47461a1.75 1.75 0 0 0-1.75 1.75v6.8828l0.0078125 0.16992a1.75 1.75 0 0 0 1.7422 1.5801h1.6523l2.0391 2.666 2.209-2.666h4.5996a1.75 1.75 0 0 0 1.75-1.75v-6.8828a1.75 1.75 0 0 0-1.75-1.75h-10.5zm1.8828 2.916h6.7344c0.395 0 0.71484 0.32847 0.71484 0.73047a0.723 0.723 0 0 1-0.71484 0.72852h-6.7344c-0.395 0-0.71484-0.32652-0.71484-0.72852a0.723 0.723 0 0 1 0.71484-0.73047zm-0.10352 2.918h5.7734c0.339-1e-7 0.61523 0.32652 0.61523 0.72852 0 0.403-0.27623 0.73047-0.61523 0.73047h-5.7734c-0.339 0-0.61133-0.32847-0.61133-0.73047-1e-7 -0.403 0.27233-0.72852 0.61133-0.72852z"
  });
};

var _default = (0, _createSvgIcon["default"])(CommentFilled, {
  viewBox: viewBox
});

exports["default"] = _default;